import React from 'react'
import PropTypes from 'prop-types'

import { useDispatch, useSelector } from 'react-redux'
import { selectHash } from '@selectors'

import { submitCardDropDownAction } from '@redux/actions/priority'

import { DropDownItem } from '@omnilert/components'

import useStyles from './card-dropdown-menu-item.style'
import i18n from 'i18n-js'
import { PRIORITY_FALSE_POSITIVE, PRIORITY_MENU_RESOLVE } from '../../assets/i18n/strings'

const CardDropdownMenuItem = ({ data, onClick, variant }) => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const { headers, method, postData, text, url } = data

  const pac = useSelector(selectHash)

  const translateText = (text) => {
    switch (text) {
    case 'False Positive':
      return i18n.t(PRIORITY_FALSE_POSITIVE)
    case 'Resolve Issue':
      return i18n.t(PRIORITY_MENU_RESOLVE)
    default:
      return text
    }
  }

  const handleOnClick = () => {
    const submitData = { ...postData, personal_access_code: pac }

    const payload = {
      request: {
        method,
        url,
        data: submitData,
        headers
      },
      setLoading: {
        meta: submitData.id
      }
    }

    dispatch(submitCardDropDownAction({ payload }))

    onClick()
  }

  return (
    <DropDownItem
      key={`item-${text}`}
      className={classes.dropdownItem}
      onClick={handleOnClick}
      type={variant}
    >
      {translateText(text)}
    </DropDownItem>
  )
}

CardDropdownMenuItem.defaultProps = {
  variant: ''
}

CardDropdownMenuItem.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string
}

export default CardDropdownMenuItem
